import { post } from "@utils/httpUtil";

// 查询新社区详情
export function findNewCommunityDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/hc/detail`, data, config);
}

// 保存新社区详情
export function saveNewCommunityDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/hc/insert`, data, config);
}

// 获取推广信息
export function getPromotionInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/hc/getPromotionInfo`, data, config);
}

// 获取推广信息-医学首页
export function getDCPromotionInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/dc/getPromotionInfo`, data, config);
}

// 保存linkcard-健康首页
export function saveLinkcard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/hc/saveLinkcard`, data, config);
}

// 保存linkcard-医生首页
export function saveDCLinkcard(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/dc/saveLinkcard`, data, config);
}

// 获取社区认证主体信息
export function findQualificationCommunityMain(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/findQualificationCommunityMain`, data, config);
}
